import i18n from '@/utils/i18n';
import React from 'react';
import { Button } from './button';
import { CameraPermissionStatus } from '@/react-native-vision-camera';
import { onViewSettings } from '@/hooks/use-permission-denied-alert';
import { SCREEN_PADDING, TYPOGRAPHY } from '@/styles';
import { StyleSheet, Text, View } from 'react-native';

interface Props {
  cameraPermissionStatus: CameraPermissionStatus;
  onBackPress: () => void;
  requestCamera: () => Promise<CameraPermissionStatus | null>;
}

export const CameraPermissionPrompt: React.FC<Props> = ({
  cameraPermissionStatus,
  onBackPress,
  requestCamera,
}) => {
  return (
    <View style={styles.base}>
      <Text style={[TYPOGRAPHY.cardHeaderText, styles.deniedTitle]}>
        {i18n.t('allow_camera_access')}
      </Text>
      <Text style={[TYPOGRAPHY.medium, styles.deniedDescription]}>
        {i18n.t('use_camera_to_scan')}
      </Text>
      <View style={styles.buttonRow}>
        <Button
          containerStyle={styles.buttonContainerLeft}
          onPress={onBackPress}
          style={styles.buttonStyle}
          trackingData={{
            name: 'camera_permissions_view.go_back_button',
          }}
          type="tertiary"
        >
          {i18n.t('not_now')}
        </Button>
        <Button
          containerStyle={styles.buttonContainerRight}
          onPress={async () => {
            if (cameraPermissionStatus === 'not-determined') {
              await requestCamera();
            } else {
              onViewSettings();
            }
          }}
          style={styles.buttonStyle}
          trackingData={{
            name: 'camera_permissions_view.turn_on_button',
          }}
        >
          {i18n.t('turn_on')}
        </Button>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  base: {
    paddingHorizontal: SCREEN_PADDING,
  },
  buttonContainerLeft: {
    flex: 1,
    marginRight: 8,
  },
  buttonContainerRight: {
    flex: 1,
    marginLeft: 8,
  },
  buttonRow: {
    flexDirection: 'row',
  },
  buttonStyle: {
    height: 56,
  },
  deniedDescription: {
    lineHeight: 22,
    marginBottom: 16,
    textAlign: 'center',
  },
  deniedTitle: {
    marginBottom: 16,
  },
});
